import React, { useEffect, useContext } from "react";
import "./Home.scss";
import Banner from "./Banner/Banner";
import Categories from "./Categories/Categories";
import Featured from "../Products/Featured/Featured";
import { fetchDataFromApi } from "../../utils/api";
import { Context } from "../../utils/context";
import {client} from '../../lib/client'

const Home = ({ products, categories}) => {
    console.log(products)
   

   

    return (
        <div>
            <Banner />
            <div className="main-container">
            <div className="main-content-container">
                <div className="layout">
                    <Categories headingText="Popular Brands"categories={categories} products={products} />
                    <Featured
                        headingText="Popular Products"
                        products={products}
                    />
                </div>
            </div>
            </div>
        </div>
    );
};

export const getServerSideProps = async () => {
    const query = '*[_type == "product]';
    const products = await client.fetch(query);
    console.log(products)

    const categoryQuery = '*[_type == "category"]';
    const categories = await client.fetch(categoryQuery);

    return {
        props: { products, categories}
    }
}
export default Home;
